<template>
  <div
    class="svg-container"
    role="button"
    tabindex="0"
    title="点击查看大图"
    @click="openPreview"
    @keydown.enter.prevent="openPreview"
    @keydown.space.prevent="openPreview"
  >
    <img :src="mapSrc" class="svg-object" alt="象山地图" />
  </div>
  <teleport to="body">
    <div
      v-if="showPreview"
      class="home-map-lightbox"
      role="dialog"
      aria-modal="true"
      aria-label="地图大图"
      @click.self="closePreview"
    >
      <button type="button" class="home-map-lightbox-close" aria-label="关闭" @click="closePreview">
        ×
      </button>
      <img :src="mapSrc" class="home-map-lightbox-img" alt="象山地图" />
    </div>
  </teleport>
</template>

<script>
export default {
  name: 'HomeMap',
  data() {
    return {
      showPreview: false,
      mapSrc: require('@/assets/svg/home12.png')
    }
  },
  watch: {
    showPreview(val) {
      if (val) {
        document.addEventListener('keydown', this.onEsc)
      } else {
        document.removeEventListener('keydown', this.onEsc)
      }
    }
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.onEsc)
  },
  methods: {
    openPreview() {
      this.showPreview = true
    },
    closePreview() {
      this.showPreview = false
    },
    onEsc(e) {
      if (e.key === 'Escape') {
        this.closePreview()
      }
    }
  }
}
</script>

<style scoped>
.svg-container {
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  background: transparent;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding-top: 20px;
  padding-bottom: 120px;
  cursor: pointer;
}

.svg-container:focus {
  outline: 2px solid rgba(77, 138, 255, 0.8);
  outline-offset: 2px;
}

.svg-object {
  display: block;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  object-position: center;
  background: transparent;
  user-select: none;
  pointer-events: none;
}

.home-map-lightbox {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 52px 6px 6px 6px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.82);
}

.home-map-lightbox-close {
  position: absolute;
  top: 20px;
  right: 28px;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  font-size: 32px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.home-map-lightbox-close:hover {
  background: rgba(255, 255, 255, 0.22);
}

.home-map-lightbox-img {
  display: block;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  object-position: center;
  background: transparent;
  user-select: none;
  pointer-events: none;
}
</style>
